import React from "react";
import { Link } from "react-router-dom";

export const HistoryItem = ({ data }) => {
  return (
    <Link
      to={`/emergency/history/details?${data.id}`}
      className='serviceHistoryItem'>
      <div className='recipt'>
        <span>{data.car_name}</span>
        <span>شماره فاکتور : {data.id}</span>
      </div>
      <div className='serviceType'>
        <div>
          <span>نوع خدمت :</span>
          <span>{data.services[0].title}</span>
        </div>
        <span>{data.date}</span>
      </div>
    </Link>
  );
};
